'use client';

import { Crown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { leaderboardData } from '../../../lib/games-data';

export function LeaderboardSection() {
  return (
    <div className="relative bg-gradient-to-br from-indigo-50 via-white to-purple-50 p-8 rounded-[40px] shadow-xl overflow-hidden">
      
      <div className="absolute -top-10 -right-10 w-40 h-40 bg-purple-300/20 rounded-full" />
      <div className="absolute bottom-0 left-0 w-32 h-32 bg-indigo-300/10 rounded-full" />

      {/* Header */}
      <div className="relative z-10 flex items-center justify-between mb-8">
        <h3 className="text-2xl font-extrabold text-slate-800 tracking-tight">
          🏆 Live Leaderboard
        </h3>

        <span className="px-4 py-1.5 bg-gradient-to-r from-yellow-400 to-orange-400 text-white rounded-full text-xs font-extrabold shadow-lg">
          LIVE
        </span>
      </div>

      {/* Leaderboard List */}
      <div className="relative z-10 space-y-4">
        {leaderboardData.map((player) => {
          const isTopThree = player.rank <= 3;
          const isFirst = player.rank === 1;

          return (
            <div
              key={player.rank}
              className={`group relative flex items-center gap-4 p-4 rounded-3xl transition-all duration-300 shadow-md
              ${
                isTopThree
                  ? 'bg-gradient-to-r from-yellow-100 to-yellow-50 border border-yellow-200'
                  : 'bg-white hover:scale-[1.02]'
              }
              ${
                player.current
                  ? 'ring-2 ring-teal-400 bg-teal-50'
                  : ''
              }`}
            >
              {/* Rank */}
              <div
                className={`text-lg font-extrabold w-6 text-center ${
                  isFirst
                    ? 'text-yellow-500'
                    : isTopThree
                    ? 'text-orange-500'
                    : 'text-slate-400'
                }`}
              >
                {player.rank}
              </div>

              {/* Avatar */}
              <div
                className={`relative w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg shadow-md
                ${
                  isFirst
                    ? 'bg-gradient-to-br from-yellow-400 to-orange-400 text-white'
                    : 'bg-slate-100'
                }`}
              >
                {player.avatar}

                {/* Crown for #1 */}
                {isFirst && (
                  <Crown className="absolute -top-3 h-5 w-5 text-yellow-500" />
                )}
              </div>

              {/* Name & Points */}
              <div className="flex-1">
                <p className="font-bold text-slate-800">
                  {player.name}
                  {player.current && (
                    <span className="ml-2 text-xs bg-teal-500 text-white px-2 py-0.5 rounded-full">
                      YOU
                    </span>
                  )}
                </p>

                <p className="text-sm font-semibold text-slate-500">
                  {player.points.toLocaleString()} PTS
                </p>
              </div>

              {/* Bonus Indicator */}
              {player.current && (
                <span className="text-sm font-bold text-teal-600">
                  +150
                </span>
              )}
            </div>
          );
        })}
      </div>

      {/* CTA Button */}
      {/* <Button
        variant="outline"
        className="relative z-10 w-full mt-8 py-3 rounded-3xl font-extrabold text-slate-700 border-2 border-slate-200 hover:bg-white shadow-md hover:shadow-lg transition-all"
      >
        View Full Rankings →
      </Button> */}
    </div>
  );
}
